import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSupportData } from '../features/support/supportSlice';
import { CircularProgress, Box, Typography,Button} from '@mui/material';

const DataLoader = ({ children }) => {
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.support);

  useEffect(() => {
    dispatch(fetchSupportData());
  }, [dispatch]);

  if (error) {
    return (
  <Box 
  sx={{ 
    display: 'flex', 
    flexDirection: 'column',
    justifyContent: 'center', 
    alignItems: 'center', 
    height: '100vh',
    padding: 3,
    backgroundColor: '#f5f5f5'
  }}
>
  <Box
    sx={{
      backgroundColor: 'white',
      borderRadius: 2,
      padding: 4,
      maxWidth: 500,
      width: '100%',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      textAlign: 'center'
    }}
  >
    {/* Error Icon */}
    <Box
      sx={{
        width: 64,
        height: 64,
        borderRadius: '50%',
        backgroundColor: '#ffebee',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto 16px'
      }}
    >
      <Typography 
        sx={{ 
          fontSize: 32,
          color: '#d32f2f'
        }}
      >
        ⚠️
      </Typography>
    </Box>

    {/* Error Title */}
    <Typography 
      variant="h5" 
      sx={{ 
        fontWeight: 600,
        color: '#212121',
        marginBottom: 1
      }}
    >
      Something Went Wrong
    </Typography>

    {/* User-friendly message */}
    <Typography 
      sx={{ 
        color: '#666',
        marginBottom: 3,
        lineHeight: 1.6
      }}
    >
      We’re currently experiencing technical difficultie. 
      Our system is temporarily unavailable. Please try again later.
    </Typography>

    {/* Technical details (collapsible or smaller) */}
    <Box
      sx={{
        backgroundColor: '#fafafa',
        padding: 2,
        borderRadius: 1,
        marginBottom: 3,
        border: '1px solid #e0e0e0'
      }}
    >
      <Typography 
        variant="caption" 
        sx={{ 
          color: '#757575',
          fontFamily: 'monospace'
        }}
      >
        Error: {error}
      </Typography>
    </Box>

    {/* Action Button */}
    <Button
      variant="contained"
      onClick={() => window.location.reload()}
      sx={{
        backgroundColor: '#1976d2',
        '&:hover': {
          backgroundColor: '#1565c0'
        },
        textTransform: 'none',
        paddingX: 3
      }}
    >
      Try again
    </Button>
  </Box>
</Box>
    );
  }

  if (loading) {
    return (
      <Box   sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          background: `linear-gradient(195deg, #0a2e52 0%, #1565C0 150%)`,
        }}
      
      >
         <Box textAlign="center">
                     <CircularProgress
                       size={60}
                       thickness={4}
                       sx={{ color: "white", mb: 2 }}
                     />
                     <Typography variant="h6" color="white">
                       Loading.....
                     </Typography>
                   </Box>
      </Box>
    );
  }

  return children;
};

export default DataLoader;